import { Typography } from 'ucl/components/text/Typography';

import { LoyaltyQuestIncentiveType } from 'generated/graphql-gateway';
import { t } from 'state/intl/translations';

const incentiveTypeMessageMap: Record<LoyaltyQuestIncentiveType, string> = {
  [LoyaltyQuestIncentiveType.BADGE]: 'Badge',
  [LoyaltyQuestIncentiveType.BONUS_POINTS]: 'Crowns',
  [LoyaltyQuestIncentiveType.OFFER]: 'Offer',
  [LoyaltyQuestIncentiveType.REWARD]: 'Reward',
};

export const IncentiveMessage = ({
  incentiveType,
}: {
  incentiveType: LoyaltyQuestIncentiveType;
}) => {
  const incentiveMessage = t('incentiveMessage', {
    incentiveType: incentiveTypeMessageMap[incentiveType],
  });

  return <Typography variant="copyTwo">{incentiveMessage}</Typography>;
};
